import Items from './Items'

const initialState = {
  error : false,
  systemId : null,
  perPage : 100,
  total : 0,
  items : []
}

module.exports = Items.reducer( initialState, 'SYSTEM_USER', 'systemId', [ 'systemId' ] )
